// @flow
import { memo } from "react";
import { hideVisually } from "polished";

import { useMessage } from "../hooks/useI18n";

type MessageProps = {
  +className?: string,
  +id: string,
  +defaultMessage?: string | null,
  +children?: string,
  +data?: Object | null,
  +screenreaderOnly?: boolean,
  +allowHTML?: boolean,
};

/**
 * Message React component
 */
const Message: React$AbstractComponent<MessageProps, mixed> =
  memo<MessageProps>(
    ({
      className,
      id,
      defaultMessage,
      children,
      data,
      screenreaderOnly = false,
      allowHTML = false,
    }: MessageProps) => {
      const translatedMessage = useMessage(
        id,
        defaultMessage || children,
        data,
      );

      if (screenreaderOnly) {
        const styles = {
          ...hideVisually(),
        };

        return (
          <span className={className} style={styles}>
            {translatedMessage}
          </span>
        );
      }

      if (allowHTML) {
        return (
          <span
            className={className}
            dangerouslySetInnerHTML={{
              __html: translatedMessage,
            }}
          />
        );
      }

      return <span className={className}>{translatedMessage}</span>;
    },
  );

Message.displayName = "BI.Message";

export default Message;
